var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: 314,
    viewBox: "0 0 100% 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: 314,
    fill: "#E8192C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2039_21004",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: "100%",
    height: 314
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: 314,
    fill: "#E8192C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2039_21004)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.16,
    cx: "100%",
    cy: -33,
    r: 166,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.16,
    cy: 369,
    r: 166,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2039_21004)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 475,
    r: 243,
    fill: "#FD8F3F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2039_21004",
    x: -221,
    y: 47,
    width: 856,
    height: 856,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92.5,
    result: "effect1_foregroundBlur_2039_21004"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBg);
export default __webpack_public_path__ + "static/media/header_bg.b84a3e9b7d5d05382965c81bcbd3654d.svg";
export { ForwardRef as ReactComponent };